/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import NavbarBg from "../../../assets/images/NavbarBg.svg";
import BSGLogo from "../../../assets/images/Logo.svg";
// import {
//   Menu,
//   MenuItem,
//   SubMenu,
// } from '@szhsin/react-menu';
// import '@szhsin/react-menu/dist/index.css';

const HeaderContainer = styled.header`
  background: #4c4e8d;
  display: flex;
  align-items: center;
  height: 80px;
  width: 100%;
`;

const Logo = styled.img`
  width: 50px;
  height: 50px;
`;

const LogoContainer = styled.div`
  // width: 12%;
  gap: 10px;
  margin-left: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoText = styled.p`
  color: #bebfeb;
  font-family: Noto Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
`;

const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const Tab = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  margin-right: 50px;
  color: #ffffff;
  cursor: pointer;
`;

const Btn = styled.button`
  background-color: rgba(0, 0, 0, 0);
  color: white;
  padding: 10px;
  border: 1px solid #d9dee1;
`;

const BtnContainer = styled.div`
  width: 12%;
`;

// const Header = () => {
//   const [masterSetupDropdownAnchorEl, setMasterSetupDropdownAnchorEl] = useState(null);
//   const [memberDropdownAnchorEl, setMemberDropdownAnchorEl] = useState(null);
//   const [setupDetailsDropdownAnchorEl, setSetupDetailsDropdownAnchorEl] = useState(null);
//   const navigate = useNavigate();

//   const tabs = [
//     'Activate Contribution Rights',
//     'Message Ticker',
//     'Activate Online Contribution',
//     'Contribution Collection to Deposit',
//     'Setup Details',
//   ];

//   const handleTabClick = (tab) => (event) => {
//     if (tab === 'masterSetup') {
//       setMasterSetupDropdownAnchorEl(event.currentTarget);
//       setMemberDropdownAnchorEl(null);
//     } else if (tab === 'member') {
//       setMemberDropdownAnchorEl(event.currentTarget);
//       setMasterSetupDropdownAnchorEl(null);
//     } else if (tab === 'masterSetupDetails') {
//       setSetupDetailsDropdownAnchorEl(event.currentTarget);
//     } else {
//       setMasterSetupDropdownAnchorEl(null);
//       setMemberDropdownAnchorEl(null);
//       setSetupDetailsDropdownAnchorEl(null);
//     }
//   };

//   const handleCloseMasterSetupDropdown = () => {
//     setMasterSetupDropdownAnchorEl(null);
//   };

//   const handleCloseMemberDropdown = () => {
//     setMemberDropdownAnchorEl(null);
//   };

//   const handleCloseSetupDetailsDropdown = () => {
//     setSetupDetailsDropdownAnchorEl(null);
//   };

//   const handleOptionClick = (option) => {
//     console.log(option);
//     if (option === 'Activate Contribution Rights') {
//       handleCloseMasterSetupDropdown();
//       navigate('/');
//     } else if (option === 'Setup Details') {
//       // handleCloseMasterSetupDropdown();
//       setSetupDetailsDropdownAnchorEl(document.getElementById('masterSetupTab'));
//     } else if (option === 'Payable City') {
//       handleCloseMasterSetupDropdown();
//       navigate('/master-setup/setup-details/payable-city');
//     }

//   };

//   return (
//     <HeaderContainer>
//       <LogoContainer>
//         <Logo src={BSGLogo} alt="Logo" />
//       </LogoContainer>
//       <Tabs>
//         <Tab onClick={handleTabClick('home')}>Home</Tab>
//         <Tab id="masterSetupTab" onClick={handleTabClick('masterSetup')}>
//           Master Setup
//         </Tab>
//         <Tab onClick={handleTabClick('member')}>Member</Tab>
//         <Tab onClick={handleTabClick('regularContribution')}>Regular contribution</Tab>
//         <Tab onClick={handleTabClick('reports')}>Reports</Tab>
//       </Tabs>
//       <BtnContainer>
//         <Btn>Contribution Admin</Btn>
//       </BtnContainer>
//       <Dropdown
//         tabs={tabs}
//         anchorEl={masterSetupDropdownAnchorEl}
//         onClose={() => {
//           if (!tabs.includes('Setup Details')) {
//             handleCloseMasterSetupDropdown();
//           }
//         }}
//         handleOptionClick={handleOptionClick}
//       />
//       <Dropdown
//         tabs={['Option 1', 'Option 2', 'Option 3']}
//         anchorEl={memberDropdownAnchorEl}
//         onClose={handleCloseMemberDropdown}
//       />
//       <Dropdown
//         tabs={[
//           'Receipt types',
//           'Payable City',
//           'Contribution Cycle',
//           'Bank Details',
//         ]}
//         anchorEl={setupDetailsDropdownAnchorEl}
//         onClose={handleCloseSetupDetailsDropdown}
//         handleOptionClick={handleOptionClick}
//         position={{ top: '25%', left: '21%' }}
//         positiondesktop={{ top: '15%', left: '14%' }}
//       />
//     </HeaderContainer>
//   );
// };

// export default Header;

function Header() {
  const navigate = useNavigate();

  const handleReceiptTypes = () => {
    navigate("/master-setup/setup-deatils/receipt-types");
  };

  const handlePayableCity = () => {
    navigate("/master-setup/setup-details/payable-city");
  };

  const handleBankDetails = () => {
    navigate("/master-setup/setup-deatils/bank-details");
  };

  return (
    <HeaderContainer>
      <LogoContainer>
        <Logo src={BSGLogo} alt="Logo" />
        <LogoText>Contribution Admin</LogoText>
      </LogoContainer>
      {/* <Tabs>
        <Tab >Home</Tab>
        <Menu menuButton={<Tab>Master Setup</Tab>}>
        <MenuItem>Activate Contribution Rights</MenuItem>
        <MenuItem>Message Ticker</MenuItem>
        <MenuItem>Activate Online Contribution</MenuItem>
        <MenuItem>Contribution Collection to Deposit(New)</MenuItem>
        <SubMenu label="setup Details">
           <MenuItem onClick={handleReceiptTypes}>Receipt Type</MenuItem>
           <MenuItem onClick={handlePayableCity}>Payable City</MenuItem>
           <MenuItem>Contribution Cycle</MenuItem>
           <MenuItem onClick={handleBankDetails}>Bank Details</MenuItem>
        </SubMenu>
      </Menu>
        <Tab>Member</Tab>
        <Tab>Regular contribution</Tab>
        <Tab>Reports</Tab>
      </Tabs> */}
      {/* <BtnContainer>
        <Btn>Contribution Admin</Btn>
      </BtnContainer> */}
    </HeaderContainer>
  );
}

export default Header;
